import { Tooltip } from 'shared/ui/Tooltip';
import { MaterialIcon } from 'shared/ui/MaterialIcon';
import { useMemo } from 'react';
import classNames from 'classnames';
import { BudgetInput } from 'shared/ui/Input';
import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';
import { BLOCKING_BUDGET_INPUT_MESSAGE, type PendingChangesResult } from 'entities/campaign';
import { useContractorDateWithTimeZone } from 'shared/lib/timezones';

import { WEEKLY_BUDGET_INFO_MESSAGE } from './constants';

interface WeeklyBudgetFieldProps {
  isBudgetBlocked: boolean;
  editDialogIsShown: boolean;
  isWeeklyBudget: boolean;
  transitionEnd: boolean;
  appliesAt: string | null;
  pendingChanges: PendingChangesResult;
}

export function WeeklyBudgetField(props: WeeklyBudgetFieldProps) {
  const { editDialogIsShown, appliesAt, isBudgetBlocked, isWeeklyBudget, transitionEnd, pendingChanges } = props;

  const getPendingDate = useContractorDateWithTimeZone();
  const formattedAppliesAt = appliesAt && getPendingDate(appliesAt);

  const inputIcon = useMemo(() => {
    if (pendingChanges.budget) {
      return {
        testName: 'icon-pending',
        color: 'text-orange-500',
        iconName: 'update',
        tooltipText: `${BLOCKING_BUDGET_INPUT_MESSAGE} ${formattedAppliesAt}`,
      };
    }

    return {
      testName: 'icon-info',
      color: 'text-slate-300 hover:text-deep-blue-500',
      iconName: 'info',
      tooltipText: WEEKLY_BUDGET_INFO_MESSAGE,
      isDisabled: false,
    };
  }, [pendingChanges.budget]);

  return (
    <div className="relative">
      <BudgetInput
        attributes={{
          maxLength: 9,
        }}
        disabled={isBudgetBlocked || !editDialogIsShown}
        name="budget"
        isFocused={editDialogIsShown && isWeeklyBudget && transitionEnd}
        placeholder="Weekly budget"
        thousandSeparator
        {...getDataAutoTestAttributes(['input-campaign-edit-weekly-budget'])}
      />
      <Tooltip
        isDisabled={inputIcon.isDisabled}
        placement="bottom-end"
        content={inputIcon.tooltipText}
      >
        <MaterialIcon
          {...getDataAutoTestAttributes([inputIcon.testName])}
          className={classNames('absolute cursor-pointer right-5 top-[18px] text-base', inputIcon.color)}
        >
          {inputIcon.iconName}
        </MaterialIcon>
      </Tooltip>
    </div>
  );
}
